export const FOCUS_OUTLINE_IN_FIREFOX = {
  '&:focus': {
    '@-moz-document url-prefix()': {
      outline: '2px solid blue',
      boxShadow: '0 0 0 3px white'
    }
  }
};
